module.exports = __webpack_public_path__ + "img/required_club_logo.61a963e4.png";